import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import styles from './button.scss'

export interface IProps {
  innerRef?: React.RefObject<HTMLButtonElement>
  className?: string
  children: React.ReactChild
  wide?: boolean
  ghost?: boolean
  blue?: boolean
  green?: boolean
  red?: boolean
  disabled?: boolean
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const Button = ({
  innerRef,
  className,
  children,
  ghost = false,
  wide = false,
  blue = false,
  green = false,
  red = false,
  disabled,
  onClick,
  ...others
}: IProps) => {
  return (
    <button
      ref={innerRef}
      className={cn(
        styles.container,
        {
          [styles.wide]: wide,
          [styles.ghost]: ghost,
          [styles.blue]: blue,
          [styles.green]: green,
          [styles.red]: red,
          [styles.disabled]: disabled,
        },
        className
      )}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) return
        if (!onClick) return
        e.stopPropagation()
        e.preventDefault()
        onClick(e)
      }}
      {...others}
    >
      {children}
    </button>
  )
}

export default observer(Button)
